<template>
  <div class="video-column">
    <div class="video-column__data" v-if="links">
      <h3>{{ title }}</h3>
      <div v-for="(link, i) in links" :key="i">
        <div v-if="link.title !== ''">
          <a target="_blank" :href="'//' + link.link" class="video-link">
            <b>
              <p>{{ link.title }}</p>
            </b>
            <v-icon color="green">arrow_right_alt</v-icon>
          </a>
          <v-divider></v-divider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['links', 'title'],
};
</script>
